module.exports = __webpack_public_path__ + "static/img/200059.9d967544.png";